import { AxiosPublic } from "../config/axios";

export async function getBlogs(query) {
  return await AxiosPublic.get("blog", { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOneBlog(id, query) {
  return await AxiosPublic.get("blog/show/" + id, { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
